import { useEffect, useRef } from "react";

import type { TranscriptEntry } from "../lib/types";

export function Transcript({ entries }: { entries: TranscriptEntry[] }) {
  const endRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [entries.length]);

  return (
    <section className="panel transcript" aria-label="Live transcript">
      <h2 className="panel__title">Transcript</h2>

      {entries.length === 0 ? (
        <p className="panel__empty">
          Start the conversation and say hello — the transcript appears here.
        </p>
      ) : (
        <ol className="transcript__list">
          {entries.map((entry) => (
            <li key={entry.id} className={`turn turn--${entry.role}`}>
              <span className="turn__who">
                {entry.role === "user" ? "You" : "Àdùnní"}
              </span>
              <p className="turn__text">
                {entry.text}
                {/* Shown because being cut off mid-sentence is correct
                    behaviour here, not a glitch. */}
                {entry.interrupted && (
                  <span className="turn__interrupted"> — interrupted</span>
                )}
              </p>
            </li>
          ))}
        </ol>
      )}
      <div ref={endRef} />
    </section>
  );
}
